
<div class=" flex-center-center flex-direction-column" style="margin: 20px">
    <div class="logo" style="margin-bottom: 10px">
        <a routerLink="/auth/login"><img [src]="logo" width="150px"></a>
    </div>
    <app-template-form
            title="{{'reset_password' | translate}}" subtitle="{{'insert_email' | translate}}"
            style="width: 800px;max-width: 100%">
        <form [formGroup]="userForm" (submit)="recovery()">
            <mat-form-field floatLabel="auto" appearance="fill" class="w100">
                <mat-label>{{ 'email' | translate}}</mat-label>
                <input matInput id="email"
                       formControlName="email">
                <!--        <mat-error *ngIf="userForm.get('email').invalid">{{ 'email_validation' | translate}}</mat-error>-->
            </mat-form-field>

            <div class="spacerh5"></div>
            <app-huna-button [loading]="loading">
                <button mat-flat-button color="primary" class="w100" type="submit">{{ 'recovery' |translate}}
                </button>
            </app-huna-button>

        </form>
    </app-template-form>
</div>
